import Image from "../../ui/Image";
import Breadcrumb from "../Breadcrumb";

import ConsultingImg from "../../../assets/used-images/training-sec-1.png";
import ConsultingImg2 from "../../../assets/used-images/consulting-img-2.png";
import Eye from "../../../assets/used-images/eye.png";
import Msg from "../../../assets/used-images/message-star.png";

import IvoryGold from "../../../assets/used-icons/IvoryGold.svg";
import { CheckCircle, ChevronLeft, ChevronRight } from "lucide-react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import ServiceApplyBtn from "../../ui/ServiceApplyBtn";
import { useTranslation } from "react-i18next";

const ThirdSector = () => {
    const { t } = useTranslation();

    const firstSecIcons = [Eye, Msg];
    const firstSec = t('sector.firstSec', { returnObjects: true });
    const goals = t('sector.goals', { returnObjects: true });
    const productsFirstCol = t('sector.productsFirstCol', { returnObjects: true });
    const productsSecondCol = t('sector.productsSecondCol', { returnObjects: true });
    const trainingAndCertificationsArray = t('sector.trainingAndCertificationsArray', { returnObjects: true });
    const testimonialArray = t('sector.testimonialArray', { returnObjects: true });

    return (
        <>
            <Breadcrumb pages={[t('routes.services'), t('routes.third-sector')]} />
            <main className="container">
                <div className="border rounded-lg p-3">
                    <h2 className="services-header after:w-20 after:-bottom-2">
                        {t('sector.title-1')}
                    </h2>
                    <article className="text-semi-gray text-start mt-4">
                        {t('sector.desc')}
                    </article>
                </div>
                <section className="grid grid-cols-[29%_68%] gap-5 !px-4 max-lg:grid-cols-1 my-8">
                    <div className="relative">
                        <div className="w-full h-full border rounded-lg z-10 absolute -top-2 -right-4"></div>
                        <Image
                            src={ConsultingImg}
                            alt={'consulting-image'}
                            className={'rounded-lg w-full h-full z-50 relative top-4 -left-4'}
                        />
                    </div>
                    <div className="space-y-6">
                        {
                            firstSec.map((sec, i) => (
                                <div className="flex items-start gap-2 text-start" key={i}>
                                    <div className="size-14 border rounded-full">
                                        <div className="size-14 flex justify-center items-center">
                                            <img src={firstSecIcons[i]} alt={sec.title} className="w-8" />
                                        </div>
                                    </div>
                                    <div>
                                        <p className="text-secondary-tw">
                                            {sec.title}
                                        </p>
                                        <p className="text-semi-gray w-[36rem] max-lg:w-auto">
                                            {sec.desc}
                                        </p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </section>
            </main>

            {/* الاهداف */}
            <main className="bg-[#F5F5F5] pt-4 pb-4">
                <div className="container">
                    <div className="flex justify-center">
                        <p className="services-header after:-bottom-2 after:w-12 flex justify-center">
                            {t('training-courses.goals')}
                        </p>
                    </div>
                    <div className="grid grid-cols-3 gap-4 max-lg:grid-cols-1">
                        {
                            goals?.map((goal, i) => (
                                <div className="border-2 rounded-tr-3xl rounded-bl-3xl rounded-lg p-3 text-start bg-white" key={i}>
                                    {goal}
                                </div>
                            ))
                        }
                    </div>
                </div>
            </main>

            {/* منتجات وحدة القطاع */}
            <main className="container">
                <section className="relative rounded-lg" style={{ backgroundImage: `url(${ConsultingImg2})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                    <div className="absolute z-10 w-full h-full bg-gradient-to-t from-[rgba(106,47,56,0.95)] to-[rgba(84,18,37,0.95)] rounded-lg"></div>
                    <div className="relative z-20 text-white text-lg !py-9 px-3 space-y-4">
                        <p className="text-secondary-tw text-2xl font-semibold">
                            {t('sector.title-2')}
                        </p>
                        <p>
                            {t('sector.desc-2')}
                        </p>
                    </div>
                </section>

                <section className="grid grid-cols-2 gap-4 max-lg:grid-cols-1 py-5">
                    <div className="border-2 rounded-xl p-3 text-start">
                        <p className="text-secondary-tw text-xl">
                            {productsFirstCol.title}
                        </p>
                        <div className="space-y-1 my-2">
                            {
                                productsFirstCol.desc.map((item, i) => (
                                    <div className="grid grid-cols-[3%_96%] items-start gap-2" key={i}>
                                        <div>
                                            <img src={IvoryGold} alt="ivory-list" className="w-3 mt-2" />
                                        </div>
                                        <p>
                                            {item}
                                        </p>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="space-y-5 my-4">
                            <p className="text-lg text-common-text">
                                {productsFirstCol.secondTitle}
                            </p>
                            <div className="space-y-3">
                                {
                                    productsFirstCol.details.map((item, i) => (
                                        <div key={i}>
                                            <div className="flex items-center gap-2 text-secondary-tw">
                                                <div>
                                                    <CheckCircle size={13} className="mb-2.5" />
                                                </div>
                                                <p className="text-lg">
                                                    {item.title} :
                                                </p>
                                            </div>
                                            <p>
                                                {item.desc}
                                            </p>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className="grid gap-3">
                        {
                            productsSecondCol.map((pro, i) => (
                                <div className="border-2 rounded-xl p-3 text-start h-full" key={i}>
                                    <p className="text-secondary-tw text-lg mb-2">
                                        {pro.title}
                                    </p>
                                    <p>
                                        {pro.desc}
                                    </p>
                                    <div>
                                        {
                                            pro.items.map((item, iItem) => (
                                                <div key={iItem} className="grid grid-cols-[3%_96%] items-start gap-2">
                                                    <div>
                                                        <img src={IvoryGold} alt="ivory-list" className="w-3 mt-2" />
                                                    </div>
                                                    <p>
                                                        {item}
                                                    </p>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </section>
            </main>

            {/* البرامج و الشهادات */}
            <main className="px-20 pt-4 pb-24 relative max-lg:px-4 bg-primary-tw">

                <div className="flex justify-center">
                    <p className="services-header text-white after:-bottom-2 after:w-24 flex justify-center">
                        {t('sector.title-3')}
                    </p>
                </div>
                <section className="grid grid-cols-2 gap-4 max-lg:grid-cols-1 my-4">
                    {
                        trainingAndCertificationsArray.map((box, i) => (
                            <div key={i} className="border-2 border-secondary-tw rounded-lg p-3 text-white text-start bg-[#ffffff0a]">
                                <p className="text-xl">
                                    {box.title}
                                </p>
                                <p className="text-secondary-tw my-2">
                                    {box.desc}
                                </p>
                                <ul className="grid grid-cols-2 px-3">
                                    {
                                        box.items.map((item, iList) => (
                                            <li className="!list-disc" key={iList}>
                                                {item}
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        ))
                    }
                </section>
                {/* اراء الشركات */}
                <div className="flex justify-center items-center">
                    <p className="services-header text-white after:w-32 flex justify-center after:-bottom-2">
                        {t('sector.title-4')}
                    </p>
                </div>

                <section className="absolute z-50 -bottom-[22rem] w-11/12 flex items-center justify-center gap-4 max-lg:gap-2 max-lg:-bottom-[28rem]">
                    <button className="prev-test flex justify-center items-center p-1 rounded-md border-2 border-secondary-tw text-secondary-tw" title="Next">
                        <ChevronRight size={20} />
                    </button>
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        slidesPerView={1}
                        spaceBetween={30}
                        navigation={{
                            nextEl: '.next-test',
                            prevEl: '.prev-test'
                        }}
                        loop={true}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        breakpoints={{
                            300: { slidesPerView: 1 },
                            776: { slidesPerView: 2 },
                            1024: { slidesPerView: 3 },
                            1600: { slidesPerView: 4 },
                        }}
                        className="p-3"
                    >
                        {
                            testimonialArray.map((test, i) => (
                                <SwiperSlide key={i} className="w-full rounded-lg bg-white border-2 border-secondary-tw">
                                    <div className="w-full">
                                        <div className="bg-secondary-tw text-white w-full rounded-t-lg p-3 h-20 flex justify-center items-start">
                                            <p>{test.programTitle}</p>
                                        </div>
                                        <div className="text-start py-3 px-2 space-y-2 h-80 max-lg:h-[27rem]">
                                            <p className="text-lg font-semibold">{test.company}</p>
                                            <article className="text-gray-500">
                                                {test.companyTestimonial}
                                            </article>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))
                        }
                    </Swiper>
                    <button className="next-test flex justify-center items-center p-1 rounded-md border-2 border-secondary-tw text-secondary-tw" title="Previous">
                        <ChevronLeft size={20} />
                    </button>
                </section>
            </main>

            <div className="mt-[24rem] max-lg:mt-[30rem]">
                <ServiceApplyBtn serviceId={8} serviceName={t('routes.third-sector')} />
            </div>
        </>
    );
};

export default ThirdSector;